export default {"src":"/_next/static/media/BurgerMenu.679b337b.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};